import React from 'react';
import _ from 'lodash';

import {
  Box,
  Button
} from '@mui/material';
import {
  modalUtil,
  Table
} from 'iron-forge-react-modules';
import {
  BaseWidget,
  PermissionWall,
  SkuSwapModal
} from 'modules';

import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>({});
const SkuSwapTableComponent = Table.genTableComponent<types.ISkuSwapColumnId>({});



export interface IProps {
  orderId: string;
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.orderId);
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['skuSwap']);



  function handleClickSkuSwap() {
    setModalIsOpen('skuSwap', true);
  }

  function handleCloseSkuSwapModal() {
    setModalIsOpen('skuSwap', false);
  }

  const rows = React.useMemo(
    () => _.map(queryTuple.data.lineItems, (lineItem): types.IRow => ({
      id: lineItem.id,
      columnId2Value: {
        sku: {
          type: 'string',
          label: lineItem.sku
        },
        serialNumber: {
          type: 'string',
          label: lineItem.assignments.join(', ')
        },
        quantity: {
          type: 'string',
          label: lineItem.quantity.toString()
        }
      }
    })),
    [queryTuple]
  );

  const skuSwapRows = React.useMemo(
    () => _.map(queryTuple.data.skuSwaps, (swap): types.ISkuSwapRow => ({
      id: swap.id,
      columnId2Value: {
        purchasedSku: {
          type: 'string',
          label: swap.purchasedSku
        },
        swappedSku: {
          type: 'string',
          label: swap.swappedSku
        },
        quantity: {
          type: 'string',
          label: swap.quantity.toString()
        }
      }
    })),
    [queryTuple.data.skuSwaps]
  );

  const content = !_.isEmpty(queryTuple.data.lineItems) ? (
    <Box>
      <TableComponent
        disableSorting
        rows={rows}
        columns={[
          {
            id: 'sku',
            label: "SKU"
          },
          {
            id: 'serialNumber',
            label: "IMEI/ICCID"
          },
          {
            id: 'quantity',
            label: "Quantity"
          }
        ]} />
    </Box>
  ) : (
    <Box>
      Not fulfilled yet
    </Box>
  );

  const skuSwapContent = !_.isEmpty(queryTuple.data.skuSwaps) && (
    <Box>
      <SkuSwapTableComponent
        disableSorting
        rows={skuSwapRows}
        columns={[
          {
            id: 'purchasedSku',
            label: "Purchased SKU"
          },
          {
            id: 'swappedSku',
            label: "Swapped SKU"
          },
          {
            id: 'quantity',
            label: "Quantity"
          }
        ]}
      />
    </Box>
  );

  return (
    <>
      <BaseWidget.FC
        title="Item Fulfillment"
        elAction={(
          <PermissionWall.FC
            storeId={props.storeId}
            requiresPermissions={['inventory_createSkuSwap']}>
            <Button onClick={handleClickSkuSwap}>
              SKU Swap
            </Button>
          </PermissionWall.FC>
        )}>
        {content}

        {skuSwapContent}
      </BaseWidget.FC>

      {modalType2IsOpen.skuSwap && (
        <SkuSwapModal.FC
          orderId={props.orderId}
          onClose={handleCloseSkuSwapModal} />
      )}
    </>
  );
};
